import React, { useState } from "react";
import { Modal } from 'react-bootstrap';
import RadioButtonQuest from '../../../UI/RadioButtonQuest';
import GtmDataLayer from "../../../../Utility/GtmDataLayer";

const ClosedYear = ({ clsName, onSelectAnswer, unQualifiedAnswer }) => {

    const optionHandle = async (e) => {
        onSelectAnswer(e);
    }

    return (
        <>
            <div className={`qsSlider slidea1 ${clsName}`}>
                <h2 className="qs-title slide-up-now">
                    Was your account closed over 6 years ago?
                </h2>
                <div className="btn-option optinal-items singleqs slide-up-now">
                    <div className=" option_but mb-3">
                        <RadioButtonQuest
                            key="cy1"
                            className="radio"
                            labelName="Yes"
                            onClick={optionHandle}
                            value="377"
                            name="closedyear"
                            id="cy1"
                            dataQuestId={122}
                            dataAnsId={377}
                            dataAnsLabel="Yes"
                        />
                    </div>
                    <div className=" option_but  mb-3">
                        <RadioButtonQuest
                            key="cy2"
                            className="radio"
                            labelName="No"
                            onClick={optionHandle}
                            value="378"
                            name="closedyear"
                            id="cy2"
                            dataQuestId={122}
                            dataAnsId={378}
                            dataAnsLabel="No"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClosedYear;
